module.exports = __webpack_public_path__ + "static/img/02_05_eq.71863bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/02_05_eq.png
// module id = FSy9
// module chunks = 12